import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import queryString from "query-string";
import { Tabs, Tab } from "react-bootstrap";
import LoadingProgress from '../../components/utilComponents/LoadingProgress';
import {
  getAccountById,
  clearAccountRec,
  accountBasicInfoFieldChange,
  accountAddressFieldChange,
  accountTimePlanFieldChange,
  onAccountServiceCallRateSubmit,
  setSelectedAccountRatePlan,
  accountDefaultLocationFieldChange,
  accountBillableChange,
  addRemoveBillableIndex,
  addUpdatBillableIndex,
  accountRatePlanFieldChange,
  addLink,
  getListOfAccountsLink,
  deleteLink,
  accountRatePlanDiscountAllFieldChange,
  loadAccountDefaultRatePlan,
  onSaveAccount,
  setBillAddressAsAccountAddress,
  setAccountNotesToList,
  setBillingNotesToList,
  setAccountContactToList,
  setBillingContactToList,
  deleteContactToList,
  deleteNoteToList,
  activeInactiveAccount,
  addCustomCharges,
  removeCustomCharges,
  accountRatePlanCustomFieldChange,
  accountDefaultLocationAddressChange,
  getAssignedCompList,
  setBillableStatus,
} from "../../actions/adminAction/accountAction";
import {
  getChargeList,
  getEmptyChargeList,
} from "../../actions/adminAction/ratePlanActions";
import AccountInfo from "../../components/adminComponents/account/accountInfo/accountInfo";
import ChargeSettings from "../../components/adminComponents/account/accountInfo/customChgMonetizationCongiList";
import { notify } from "../../util/notifications";
import Billing from "../../components/adminComponents/account/billing/billing";
import Billing_ARS from "../../components/adminComponents/account/ARS_Config/Billing_ARS";
import DefaultAddress from "../../components/adminComponents/account/defaultInfo/defaultAddress";
import AccountAssignedComp from "../../components/adminComponents/account/accountAssignedComp";
import AccountHistory from "../../components/adminComponents/account/accountHistory/accountHistory";
import AccountServiceCallRate from "../../components/adminComponents/account/accountServiceCallRate/accountServiceCallRate";
import AccountTaxSettings from "../../components/adminComponents/account/billing/AccountTaxSettings";
import {
  getLoginUserName,
  getCompanyId,
  isManagement,
  isRetail,
  getAccessLevelsByModule,
} from "../../util/customMethods.js";
import moment from "moment";
import { isValidForm } from "../../util/validationMethods";

// Constants
const PAGE_TITLE = "Add New Account";

const STORAGE_BEHAVIOR_CONST = {
  accRateplanId: 0,
  accountId: 0,
  custBhvrAfterAmnt: 0,
  custBhvrEndTime: 0,
  custBhvrFirstAmnt: 0,
  custBhvrFirstDays: 0,
  custBhvrId: 0,
  custBhvrNextAmnt: 0,
  custBhvrNextDays: 0,
  custBhvrStartTime: 0,
  idCompany: 0,
};

const ACCOUNT_FORM_INITIAL = {
  frmAccountInfo: {},
  frmBilling: {},
  formMonetization: {},
  frmPickAddressEntry: {},
  frmDropAddressEntry: {},
  frmDefaultAddress: {},
};

const ACCOUNT_TABS = {
  TB_ACC_ACCOUNT_INFO: "TB_ACCOUNT_ACCOUNT_INFO",
  TB_ACC_BILLING: "TB_ACC_BILLING",
  TB_ACC_ARS: "TB_ACC_ARS",
  TB_ACC_DEF_INFO: "TB_ACC_DEF_INFO",
  TB_ACC_SERVICE_CALL_RATE: "TB_ACC_SERVICE_CALL_RATE",
  TB_ACC_HISTORY: "TB_ACC_HISTORY",
  TB_ACC_PAYMENT_SETTING: "TB_PAYMENT_SETTING",
  TB_ACC_COMP: "TB_ACC_COMP",
  TB_COMPANY_BILLABLE: "TB_COMPANY_BILLABLE",
};

const getNavigationFlow = () => {
  const isManagementUser = isManagement();
  const isRetailUser = isRetail();

  if (isManagementUser || isRetailUser) {
    return true
      ? [
          ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO,
          ACCOUNT_TABS.TB_ACC_BILLING,
          ACCOUNT_TABS.TB_ACC_DEF_INFO,
          ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE,
          ACCOUNT_TABS.TB_COMPANY_BILLABLE,
          ACCOUNT_TABS.TB_ACC_ARS,
          ACCOUNT_TABS.TB_ACC_HISTORY,
        ]
      : [
          ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO,
          ACCOUNT_TABS.TB_ACC_BILLING,
          ACCOUNT_TABS.TB_ACC_DEF_INFO,
          ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE,
          ACCOUNT_TABS.TB_ACC_HISTORY,
        ];
  }
  return [
    ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO,
    ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE,
  ];
};

class AccountRecPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabKey: ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO,
      aid: 0,
      modalShow: false,
      keyNo: null,
      storageBehaviorObj: Object.assign({}, STORAGE_BEHAVIOR_CONST),
      isLoading: false,
      loadingMessage: "",
      loadingProgress: 0,
    };

    this.accountForm = Object.assign({}, ACCOUNT_FORM_INITIAL);
    this.navigationFlow = getNavigationFlow();
  }

  componentWillMount = () => {
    const queryValues = queryString.parse(this.props.location.search);
    const { dispatch } = this.props;
    const accountId = parseInt(queryValues.aid) || 0;

    dispatch(clearAccountRec());
    this.setState({ aid: accountId }, () => this.initAccountForm(accountId));

    if (accountId === 0) {
      dispatch(getEmptyChargeList(queryValues.aid));
    }
    dispatch(getChargeList(queryValues.aid));
  };

  componentDidUpdate(prevProps) {
    const prevQuery = queryString.parse(prevProps.location.search);
    const currentQuery = queryString.parse(this.props.location.search);
    const prevAid = parseInt(prevQuery.aid) || 0;
    const currentAid = parseInt(currentQuery.aid) || 0;

    if (prevAid !== currentAid) {
      this.setState({ aid: currentAid }, () =>
        this.initAccountForm(currentAid)
      );
    }
  }

  // Loading state management methods
  setLoadingState = (isLoading, message = "", progress = 0) => {
    try {
      this.setState({
        isLoading,
        loadingMessage: message,
        loadingProgress: progress,
      });
    } catch (error) {
      console.warn('Failed to set loading state:', error);
      this.setState({ isLoading });
    }
  };

  simulateProgress = (callback) => {
    this.setState({ loadingProgress: 25 });

    setTimeout(() => {
      this.setState({ loadingProgress: 50 });
    }, 200);

    setTimeout(() => {
      this.setState({ loadingProgress: 75 });
    }, 400);

    setTimeout(() => {
      this.setState({ loadingProgress: 100 });
      if (callback && typeof callback === 'function') {
        callback();
      }
    }, 600);
  };

  resetLoading = () => {
    this.setState({
      isLoading: false,
      loadingMessage: '',
      loadingProgress: 0
    });
  };

  clearAllFormData = () => {
    this.accountForm = Object.assign({}, ACCOUNT_FORM_INITIAL);

    Object.keys(this.accountForm).forEach((formKey) => {
      if (
        this.accountForm[formKey] &&
        typeof this.accountForm[formKey].reset === "function"
      ) {
        this.accountForm[formKey].reset();
      }
    });

    this.forceUpdate();
  };

  checkViewAccess = (accessLevel = {}) => {
    if (accessLevel.basicAccess?.view !== true) {
      this.props.history.push("/admin/notfound");
    }
  };

  initAccountForm = (id) => {
    const { dispatch } = this.props;

    dispatch(clearAccountRec());
    this.accountForm = Object.assign({}, ACCOUNT_FORM_INITIAL);

    if (id === 0) {
      this.setState({
        tabKey: ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO,
        keyNo: null,
        storageBehaviorObj: Object.assign({}, STORAGE_BEHAVIOR_CONST),
        isLoading: false,
        loadingMessage: "",
        loadingProgress: 0,
      });
    } else {
      this.getAccountRecordById(id);
      if (isManagement() || isRetail()) {
        dispatch(getAssignedCompList(id));
        dispatch(getListOfAccountsLink(id));
      }
    }
  };

  getAccountRecordById = async (id) => {
    const { dispatch } = this.props;
    
    this.setLoadingState(true, 'Loading account information...', 50);
    
    try {
      await dispatch(getAccountById(parseInt(id)));
      this.setLoadingState(true, 'Account loaded successfully!', 100);
      
      setTimeout(() => {
        this.resetLoading();
      }, 1000);
    } catch (error) {
      this.resetLoading();
      notify.createNotification('error', 'Failed to load account information.', this.props.refNotify);
    }
  };

  getNextTab = (currentTab) => {
    const currentIndex = this.navigationFlow.indexOf(currentTab);
    return currentIndex < this.navigationFlow.length - 1
      ? this.navigationFlow[currentIndex + 1]
      : currentTab;
  };

  handleFormSubmission = async (e) => {
    const { dispatch } = this.props;
    e.preventDefault();

    const isManagementUser = isManagement();
    const isRetailUser = isRetail();
    const showManagementTabs = isManagementUser || isRetailUser;

    // Validate forms that exist and have been initialized
    const { frmAccountInfo, frmBilling, formMonetization } = this.accountForm;
    
    // Validate Account Info if form exists and has validation structure
    if (frmAccountInfo && frmAccountInfo.byId && typeof frmAccountInfo.validateAll === "function") {
      frmAccountInfo.validateAll();
      if (!isValidForm(frmAccountInfo)) {
        this.setState({ tabKey: ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO });
        notify.createNotification(
          "error",
          "Please complete the Account Information section.",
          this.props.refNotify
        );
        return;
      }
    }

    // Validate Billing if form exists and has validation structure
    if (showManagementTabs && frmBilling && frmBilling.byId && typeof frmBilling.validateAll === "function") {
      frmBilling.validateAll();
      if (!isValidForm(frmBilling)) {
        this.setState({ tabKey: ACCOUNT_TABS.TB_ACC_BILLING });
        notify.createNotification(
          "error",
          "Please complete the Billing section.",
          this.props.refNotify
        );
        return;
      }
    }

    // Validate Monetization if form exists and has validation structure
    if (showManagementTabs && formMonetization && formMonetization.byId && typeof formMonetization.validateAll === "function") {
      formMonetization.validateAll();
      if (!isValidForm(formMonetization)) {
        this.setState({ tabKey: ACCOUNT_TABS.TB_COMPANY_BILLABLE });
        notify.createNotification(
          "error",
          "Please complete the Charge section.",
          this.props.refNotify
        );
        return;
      }
    }

    this.setLoadingState(true, "Saving account information...", 0);

    this.simulateProgress(async () => {
      try {
        const res = await dispatch(onSaveAccount(this.props.accountBasicInfo));
        if (res.statusCode === 200) {
          this.setLoadingState(
            true,
            "Account saved successfully! Redirecting...",
            100
          );
          notify.createNotification(
            "success",
            res.statusMsg,
            this.props.refNotify
          );

          this.clearAllFormData();

          setTimeout(() => {
            this.resetLoading();
            this.props.history.push("/admin/account");
          }, 1000);
        } else {
          this.resetLoading();
          notify.createNotification(
            "error",
            res.statusMsg,
            this.props.refNotify
          );
        }
      } catch (error) {
        this.resetLoading();
        notify.createNotification(
          "error",
          "An error occurred while saving the account.",
          this.props.refNotify
        );
      }
    });
  };

  handleAddLink = async (obj) => {
    const { dispatch } = this.props;

    this.setLoadingState(true, "Adding link...", 50);

    try {
      obj.acc_Id = this.state.aid;
      const res = await dispatch(addLink(obj));

      if (this.state.aid !== 0) {
        dispatch(getListOfAccountsLink(this.state.aid));
      }

      this.setLoadingState(true, "Link added successfully!", 100);
      const notificationType = res.statusCode === 200 ? "success" : "error";
      notify.createNotification(
        notificationType,
        res.statusMsg,
        this.props.refNotify
      );

      setTimeout(() => {
        this.resetLoading();
      }, 1000);
    } catch (error) {
      this.resetLoading();
      notify.createNotification(
        "error",
        "An error occurred while adding the link.",
        this.props.refNotify
      );
    }
  };

  handleDeleteLink = async (id) => {
    const { dispatch } = this.props;

    this.setLoadingState(true, "Deleting link...", 50);

    try {
      const res = await dispatch(deleteLink(id));

      if (this.state.aid !== 0) {
        dispatch(getListOfAccountsLink(this.state.aid));
      }

      this.setLoadingState(true, "Link deleted successfully!", 100);
      const notificationType = res.statusCode === 200 ? "success" : "error";
      notify.createNotification(
        notificationType,
        res.statusMsg,
        this.props.refNotify
      );

      setTimeout(() => {
        this.resetLoading();
      }, 1000);
    } catch (error) {
      this.resetLoading();
      notify.createNotification(
        "error",
        "An error occurred while deleting the link.",
        this.props.refNotify
      );
    }
  };

  handleBillingSave = async (e, ind, accountId) => {
    e.preventDefault();
    const { dispatch } = this.props;

    this.setLoadingState(true, "Updating billing information...", 0);

    this.simulateProgress(async () => {
      try {
        const res = await dispatch(addUpdatBillableIndex(ind, accountId));

        if (res.statusCode === 200) {
          this.setLoadingState(true, "Billing updated successfully!", 100);
          notify.createNotification(
            "success",
            res.statusMsg,
            this.props.refNotify
          );
          this.setState({ keyNo: null });

          setTimeout(() => {
            this.resetLoading();
          }, 1000);
        } else {
          this.resetLoading();
          notify.createNotification(
            "error",
            res.statusMsg,
            this.props.refNotify
          );
        }
      } catch (error) {
        this.resetLoading();
        notify.createNotification(
          "error",
          "An error occurred while updating billing.",
          this.props.refNotify
        );
      }
    });
  };

  createNoteObject = (notesObj) => ({
    ...notesObj,
    notesDate: moment().format("MM/DD/YYYY"),
    notesTime: moment().format("HH:mm:ss"),
    accountId: this.state.aid,
    corporateId: 1,
    userId: getLoginUserName(),
  });

  handleAccountNotesSubmit = async (e, notesObj, index) => {
    const { dispatch } = this.props;
    const noteData = this.createNoteObject(notesObj);
    await dispatch(setAccountNotesToList(noteData, index));
  };

  handleBillingNotesSubmit = async (e, notesObj, index) => {
    const { dispatch } = this.props;
    const noteData = {
      ...this.createNoteObject(notesObj),
      companyId: getCompanyId(),
    };
    await dispatch(setBillingNotesToList(noteData, index));
  };

  createContactObject = (contactObj) => ({
    ...contactObj,
    accountId: this.state.aid,
    corporateId: 1,
    companyId: getCompanyId(),
  });

  handleContactSubmit = async (
    contactObj,
    index,
    success,
    fail,
    isAccount = true,
    isDefaultContact = false
  ) => {
    const { dispatch } = this.props;
    const contactData = this.createContactObject(contactObj);

    const action = isAccount
      ? setAccountContactToList(contactData, index)
      : setBillingContactToList(contactData, index, isDefaultContact);

    const res = await dispatch(action);

    if (res.statusCode === 200) {
      success(res.statusMsg);
    } else {
      fail(res.statusMsg);
    }
  };

  render() {
    const accessLevelObj = getAccessLevelsByModule("Account");
    const { accountBasicInfo } = this.props;

    document.title =
      this.state.aid === 0
        ? PAGE_TITLE
        : accountBasicInfo?.accountName || PAGE_TITLE;
    this.checkViewAccess(accessLevelObj);

    const isManagementUser = isManagement();
    const isRetailUser = isRetail();
    const showManagementTabs = isManagementUser || isRetailUser;

    return (
      <Fragment>
        <div className="page-header">
          <div className="row mb-10">
            <div className="col-md-12 col-sm-12">
              <div className="title">
                <h4>
                  <i className="fa fa-id-card"></i>
                  {this.state.aid === 0
                    ? ` ${PAGE_TITLE}`
                    : ` Edit ${accountBasicInfo?.accountName || ""}`}
                </h4>
              </div>
            </div>
          </div>
        </div>

        {/* Loading Progress Indicator */}
        <LoadingProgress 
          isLoading={this.state.isLoading}
          message={this.state.loadingMessage}
          progress={this.state.loadingProgress}
        />

        <div
          className="pd-10 bg-white border-radius-4 box-shadow container-box"
          style={{
            opacity: this.state.isLoading ? 0.7 : 1,
            pointerEvents: this.state.isLoading ? "none" : "auto",
          }}
        >
          <Tabs
            id="tab-account"
            className="tab"
            activeKey={this.state.tabKey}
            onSelect={(key) => this.setState({ tabKey: key })}
          >
            {/* Account Information Tab */}
            <Tab
              eventKey={ACCOUNT_TABS.TB_ACC_ACCOUNT_INFO}
              title={
                <span>
                  <i
                    className="fa fa-info-circle"
                    style={{ display: "block", textAlign: "center" }}
                  ></i>
                  Account Information
                </span>
              }
            >
              <AccountInfo
                callReasons={this.props.callReasons}
                accessLevel={accessLevelObj || {}}
                onTimePlanFieldChange={(keyName, value) => {
                  this.props.dispatch(
                    accountTimePlanFieldChange(keyName, value)
                  );
                }}
                initCallBack={(frm) => {
                  this.accountForm.frmAccountInfo = frm;
                }}
                accountTypes={this.props.accountTypes}
                allStates={this.props.allStates}
                salesRep={this.props.salesRep}
                reviewLocation={this.props.reviewLocation}
                accountBasicInfo={accountBasicInfo}
                onAccountBasicInfoFieldsChange={(keyName, value) => {
                  this.props.dispatch(
                    accountBasicInfoFieldChange(keyName, value)
                  );
                }}
                onAccountAddressFieldChange={(keyName, value) => {
                  this.props.dispatch(
                    accountAddressFieldChange(keyName, value)
                  );
                }}
                onAccountNotesSubmit={this.handleAccountNotesSubmit}
                onAccountContactSubmit={(
                  e,
                  contactObj,
                  index,
                  success,
                  fail
                ) => {
                  this.handleContactSubmit(
                    contactObj,
                    index,
                    success,
                    fail,
                    true
                  );
                }}
                onSubmitBasicInfo={(e) => {
                  const nextTab = showManagementTabs
                    ? ACCOUNT_TABS.TB_ACC_BILLING
                    : ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE;
                  this.setState({ tabKey: nextTab });
                }}
                onAccountContactDelete={async (index) => {
                  await this.props.dispatch(
                    deleteContactToList(this.state.aid, index, "ACCOUNT")
                  );
                }}
                onAccountNotesDelete={async (index) => {
                  await this.props.dispatch(
                    deleteNoteToList(this.state.aid, index, "ACCOUNT")
                  );
                }}
                onActiveInactiveAccount={async (status) => {
                  this.setLoadingState(true, "Updating account status...", 50);

                  try {
                    const res = await this.props.dispatch(
                      activeInactiveAccount(this.state.aid, status)
                    );
                    this.setLoadingState(true, "Account status updated!", 100);
                    const notificationType =
                      res.statusCode === 200 ? "success" : "error";
                    notify.createNotification(
                      notificationType,
                      res.statusMsg,
                      this.props.refNotify
                    );

                    setTimeout(() => {
                      this.resetLoading();
                    }, 1000);
                  } catch (error) {
                    this.resetLoading();
                    notify.createNotification(
                      "error",
                      "An error occurred while updating account status.",
                      this.props.refNotify
                    );
                  }
                }}
                onTimePlanSubmit={this.handleFormSubmission}
                disabled={this.state.isLoading}
                isNewAccount={this.state.aid === 0}
                clearFormData={this.clearAllFormData}
              />
            </Tab>

            {/* Billing Tab - Only for Management/Retail */}
            {showManagementTabs && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_BILLING}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    Billing
                  </span>
                }
              >
                <Billing
                  initCallBack={(frm) => {
                    this.accountForm.frmBilling = frm;
                  }}
                  accessLevel={accessLevelObj || {}}
                  userDefaultCharges={this.props.chargeList}
                  setBillAddressAsAccountAddress={(e) => {
                    this.props.dispatch(setBillAddressAsAccountAddress());
                  }}
                  onAccountAddressFieldChange={(keyName, value) => {
                    this.props.dispatch(
                      accountAddressFieldChange(keyName, value)
                    );
                  }}
                  onAccountBasicInfoFieldsChange={(keyName, value) => {
                    this.props.dispatch(
                      accountBasicInfoFieldChange(keyName, value)
                    );
                  }}
                  onBillingNotesSubmit={this.handleBillingNotesSubmit}
                  onBillingContactSubmit={(
                    e,
                    contactObj,
                    index,
                    success,
                    fail,
                    isDefaultContact = false
                  ) => {
                    this.handleContactSubmit(
                      contactObj,
                      index,
                      success,
                      fail,
                      false,
                      isDefaultContact
                    );
                  }}
                  allStates={this.props.allStates}
                  accountBasicInfo={accountBasicInfo}
                  onBillingInfoSubmit={(e) => {
                    this.setState({ tabKey: ACCOUNT_TABS.TB_ACC_DEF_INFO });
                  }}
                  onBillingContactDelete={async (index) => {
                    await this.props.dispatch(
                      deleteContactToList(this.state.aid, index, "BILLING")
                    );
                  }}
                  onBillingNotesDelete={async (index) => {
                    await this.props.dispatch(
                      deleteNoteToList(this.state.aid, index, "BILLING")
                    );
                  }}
                  onTimePlanSubmit={this.handleFormSubmission}
                />
              </Tab>
            )}

            {/* Default Information Tab - Only for Management/Retail */}
            {showManagementTabs && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_DEF_INFO}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    Default Information
                  </span>
                }
              >
                <DefaultAddress
                  initCallBack={(frm) => {
                    this.accountForm.frmDefaultAddress = frm;
                  }}
                  accessLevel={accessLevelObj || {}}
                  accountList={this.props.accountList || []}
                  accountBasicInfo={accountBasicInfo}
                  allStates={this.props.allStates}
                  reviewLocation={this.props.reviewLocation}
                  onAddressFieldChange={(type, keyName, value) => {
                    this.props.dispatch(
                      accountDefaultLocationFieldChange(type, keyName, value)
                    );
                  }}
                  onAddressObjectChange={(key, objAddress) => {
                    this.props.dispatch(
                      accountDefaultLocationAddressChange(key, objAddress)
                    );
                  }}
                  onSubmitDefaultAddress={(e) => {
                    this.setState({
                      tabKey: ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE,
                    });
                  }}
                  onTimePlanSubmit={this.handleFormSubmission}
                  initPickAddressCallBack={(frm) => {
                    this.accountForm.frmPickAddressEntry = frm;
                  }}
                  initDropAddressCallBack={(frm) => {
                    this.accountForm.frmDropAddressEntry = frm;
                  }}
                />
              </Tab>
            )}

            {/* Service Call Rate Tab */}
            <Tab
              eventKey={ACCOUNT_TABS.TB_ACC_SERVICE_CALL_RATE}
              title={
                <span>
                  <i
                    className="fa fa-info-circle"
                    style={{ display: "block", textAlign: "center" }}
                  ></i>
                  Service Call Rate
                </span>
              }
            >
              <AccountServiceCallRate
                accessLevel={accessLevelObj || {}}
                accountBasicInfo={accountBasicInfo}
                commissionTypes={this.props.commissionTypes}
                defaultRatePlanList={this.props.ratePlanList}
                userDefaultCharges={this.props.chargeList}
                towTypes={this.props.towTypes}
                selectedRatePlan={this.props.selectedRatePlan}
                onRatePlanChange={(ratePlanName) => {
                  this.props.dispatch(setSelectedAccountRatePlan(ratePlanName));
                }}
                accountRatePlanFieldChange={(
                  selectedPlan,
                  parentKey,
                  childKey,
                  value
                ) => {
                  this.props.dispatch(
                    accountRatePlanFieldChange(
                      selectedPlan,
                      parentKey,
                      childKey,
                      value
                    )
                  );
                }}
                accountRatePlanCustomFieldChange={(
                  selectedPlan,
                  parentKey,
                  childKey,
                  value,
                  index,
                  key
                ) => {
                  this.props.dispatch(
                    accountRatePlanCustomFieldChange(
                      selectedPlan,
                      parentKey,
                      childKey,
                      value,
                      index,
                      key
                    )
                  );
                }}
                loadAccountDefaultRatePlan={(
                  selectedPlan,
                  parentKey,
                  childKey,
                  value
                ) => {
                  this.props.dispatch(
                    loadAccountDefaultRatePlan(
                      selectedPlan,
                      parentKey,
                      childKey,
                      value
                    )
                  );
                }}
                accountRatePlanDiscountAllFieldChange={(
                  selectedPlan,
                  parentKey,
                  childKeyArray,
                  value
                ) => {
                  let _val = !value ? 0.0 : value;
                  this.props.dispatch(
                    accountRatePlanDiscountAllFieldChange(
                      selectedPlan,
                      parentKey,
                      childKeyArray,
                      _val
                    )
                  );
                }}
                onAccountServiceCallRateSubmit={async (e, accountRatePlan) => {
                  const res = await this.props.dispatch(
                    onAccountServiceCallRateSubmit(
                      accountRatePlan,
                      this.state.aid
                    )
                  );
                  const notificationType =
                    res.statusCode === 200 ? "success" : "error";
                  notify.createNotification(
                    notificationType,
                    res.statusMsg,
                    this.props.refNotify
                  );
                }}
                onAccountServiceCallRateNextClick={(e) => {
                  const nextTab = isManagementUser
                    ? ACCOUNT_TABS.TB_COMPANY_BILLABLE
                    : ACCOUNT_TABS.TB_ACC_HISTORY;
                  this.setState({ tabKey: nextTab });
                }}
                onTimePlanSubmit={this.handleFormSubmission}
                addCustomCharge={(selectedPlan, parentKey, childKey, value) => {
                  this.props.dispatch(
                    addCustomCharges(selectedPlan, parentKey, childKey, value)
                  );
                }}
                removeCustomCharge={(
                  selectedPlan,
                  parentKey,
                  childKey,
                  index
                ) => {
                  this.props.dispatch(
                    removeCustomCharges(
                      selectedPlan,
                      parentKey,
                      childKey,
                      index
                    )
                  );
                }}
              />
              <div className="row mb-10">
                <div className="col-md-12">
                  <button
                    className="btn btn-sm btn-success pull-right"
                    style={{ marginTop: "20px" }}
                    onClick={(e) => {
                      e.preventDefault();
                      const nextTab = isManagementUser
                        ? ACCOUNT_TABS.TB_COMPANY_BILLABLE
                        : ACCOUNT_TABS.TB_ACC_HISTORY;
                      this.setState({ tabKey: nextTab });
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            </Tab>

            {/* Charge Tab - Management only */}
            {isManagementUser && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_COMPANY_BILLABLE}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    Charge
                  </span>
                }
              >
                <ChargeSettings
                  initCallBack={(frm) => {
                    this.accountForm.formMonetization = frm;
                  }}
                  accountBasicInfo={accountBasicInfo}
                  keyNo={this.state.keyNo}
                  addRemoveBillableIndex={(index) => {
                    this.props.dispatch(addRemoveBillableIndex(index));
                    this.setState({ keyNo: index === 0 ? null : index - 1 });
                  }}
                  onAccountBasicInfoFieldsChange={(ind, keyName, value) => {
                    this.props.dispatch(
                      accountBillableChange(ind, keyName, value)
                    );
                  }}
                  onAccountNextClick={(e) => {
                    this.accountForm.formMonetization.validateAll();
                    if (isValidForm(this.accountForm.formMonetization)) {
                      const nextTab = ACCOUNT_TABS.TB_ACC_ARS;
                      this.setState({ tabKey: nextTab });
                    }
                  }}
                  addUpdatBillableIndex={(e, ind) => {
                    e.preventDefault();
                    this.accountForm.formMonetization.validateAll();
                    if (isValidForm(this.accountForm.formMonetization)) {
                      this.handleBillingSave(
                        e,
                        ind,
                        accountBasicInfo?.accountId
                      );
                    }
                  }}
                  onTimePlanSubmit={this.handleFormSubmission}
                  canEdit={accessLevelObj.basicAccess?.edit || false}
                  setBillableStatus={(e, chargeId) => {
                    this.props.dispatch(setBillableStatus(e, chargeId));
                  }}
                  globalChargeListData={
                    accountBasicInfo?.accountBillableChargeList || []
                  }
                />
              </Tab>
            )}

            {/* ARS Config Tab - Only for Management */}
            {isManagementUser && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_ARS}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    ARS Config
                  </span>
                }
              >
                <Billing_ARS
                  initCallBack={(frm) => {
                    this.accountForm.frmBilling = frm;
                  }}
                  accessLevel={accessLevelObj || {}}
                  aid={this.state.aid || 0}
                  Go={this.handleAddLink}
                  deleteLink={this.handleDeleteLink}
                  onAccountBasicInfoFieldsChange={(keyName, value) => {
                    this.props.dispatch(
                      accountBasicInfoFieldChange(keyName, value)
                    );
                  }}
                  onTimePlanSubmit={this.handleFormSubmission}
                  accountList={this.props.optionAccList}
                  accountBasicInfo={accountBasicInfo}
                  listOfAccountsLink={this.props.listOfAccountsLink || []}
                  next={() => {
                    this.setState({ tabKey: ACCOUNT_TABS.TB_ACC_HISTORY });
                  }}
                />
              </Tab>
            )}

            {/* History Tab - Only for Management/Retail */}
            {showManagementTabs && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_HISTORY}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>{" "}
                    History
                  </span>
                }
              >
                <AccountHistory
                  accessLevel={accessLevelObj || {}}
                  accountBasicInfo={accountBasicInfo}
                  onTimePlanSubmit={this.handleFormSubmission}
                />
              </Tab>
            )}

            {/* Assigned Companies Tab - Management only with existing account */}
            {isManagementUser && this.state.aid !== 0 && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_COMP}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    Assigned Companies
                  </span>
                }
              >
                <AccountAssignedComp
                  assignedComList={this.props.assignedComList}
                />
              </Tab>
            )}

            {/* Account Tax Settings Tab - Only for non-management with existing account */}
            {!isManagementUser && this.state.aid !== 0 && (
              <Tab
                eventKey={ACCOUNT_TABS.TB_ACC_PAYMENT_SETTING}
                title={
                  <span>
                    <i
                      className="fa fa-info-circle"
                      style={{ display: "block", textAlign: "center" }}
                    ></i>
                    Account Tax Settings
                  </span>
                }
              >
                <AccountTaxSettings accountId={this.state.aid} />
              </Tab>
            )}
          </Tabs>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    authInfo: state.authInfo,
    refNotify: state.refNotify,
    accountTypes: state.accountTypes.accountTypes,
    allStates: state.states.stateList,
    salesRep: state.salesRep.salesRep,
    reviewLocation: state.location.locationList,
    accountList: state.accountList.accountInfoList,
    selectedRatePlan: state.accountList.selectedAccRatePlan,
    accountBasicInfo: state.accountList.accountBasicInfo,
    assignedComList: state.accountList.assignedComList,
    listOfAccountsLink: state.accountList.listOfAccountsLink,
    callReasons: state.callReasons.callReasons,
    towTypes: state.towTypeList.towTypes,
    commissionTypes: state.commission.commissionTypes,
    ratePlanList: state.ratePlanList.ratePlanList,
    chargeList: state.ratePlanList.chargeList,
    optionAccList: state.invoiceInfo.accountList,
  };
};

export default withRouter(connect(mapStateToProps)(AccountRecPage));